import React from "react";
import UserInfo from "../../Components/UserInfo/UserInfo";
//import LiveSettingsWidget from "../../Components/LiveSettingsWidget/LiveSettingsWidget";
import SportPicker from "../../Components/Navigation/SportPicker/SportPicker";
import CSSClasses from "./Header.css";
import { connect } from "react-redux";
import LanguagePicker from "../../Components/Navigation/LanguagePicker/LanguagePicker";
import SettingsLive from "../../Components/Navigation/SettingsLive/SettingsLive";
import * as StoreActions from "../../ReduxStore/Actions/ActionIndex";
//import TransitionGroup from "react-transition-group/TransitionGroup";
//import CSSTransition from "react-transition-group/CSSTransition";
//import Transition from "react-transition-group/Transition";
import SiteIcons from "../../assets/fonts/site_icons/style.css";

//ikonice
import iconDown from "../../assets/images/icons/icon_sort_down.png";
import iconUp from "../../assets/images/icons/icon_sort_up.png";
import iconSettings from "../../assets/images/icons/icon_settings.png";

import beepHigh from "../../assets/sounds/beep_high.mp3";

import * as MostPlayedOptionIDs from "../../HOCs/Constants/MostPlayedOptionID";

const Header = props => {
  let headerClasses = [CSSClasses.container];
  let mainRowClass = CSSClasses.mainRowColorDefault;
  //sportovi

  if (!props.isPrematchPicker) {
    switch (props.currentLiveSportID) {
      case 1: //soccer
        mainRowClass = CSSClasses.mainRowColorSoccer;
        break;
      case 2: //basketball
        mainRowClass = CSSClasses.mainRowColorBasketball;
        break;
      case 3: //baseball
        mainRowClass = CSSClasses.mainRowColorBaseball;
        break;
      case 4: //hockey
        mainRowClass = CSSClasses.mainRowColorHockey;
        break;
      case 5: //tennis
        mainRowClass = CSSClasses.mainRowColorTennis;
        break;
      case 6: //handball
        mainRowClass = CSSClasses.mainRowColorHandball;
        break;
      case 12: //rugby
        mainRowClass = CSSClasses.mainRowColorRugby;
        break;
      case 16: //Football
        mainRowClass = CSSClasses.mainRowColorFootball;
        break;
      case 19: //Snooker
        mainRowClass = CSSClasses.mainRowColorSnooker;
        break;
      case 20: //TableTennis
        mainRowClass = CSSClasses.mainRowColorTableTennis;
        break;
      case 23: //volleyball
        mainRowClass = CSSClasses.mainRowColorVolleyball;
        break;
      case 29: //futsal
        mainRowClass = CSSClasses.mainRowColorFutsal;
        break;
      case 31: //Badminton
        mainRowClass = CSSClasses.mainRowColorBadminton;
        break;
      default:
        //titleRowClasses.push(CssClasses.colorFootball);
        break;
    }
  }

  headerClasses.push(mainRowClass);

  if (props.currentActiveLiveTheme === 2) {
    headerClasses.push(CSSClasses.lightTheme);
  }

  return (
    <div className={headerClasses.join(" ")}>
      <audio
        ref={sound => {
          this.beepHigh = sound;
        }}
      >
        <source src={beepHigh} type="audio/mpeg" />
      </audio>

      {props.hasPrematchLegend ? (
        <div
          className={[
            CSSClasses.prematchLegendContainer,
            getLegendBackground(props.activeMostPlayedButtonID)
          ].join(" ")}
        >
          <span
            className={[
              CSSClasses.legendIcon,
              getCurrentLegendIcon(props.activeMostPlayedButtonID)
            ].join(" ")}
          />
          <span className={CSSClasses.legendText}>
            {getCurrentTitle(props.activeMostPlayedButtonID)}
          </span>
          {/* &nbsp;
          <span
            className={[
              SiteIcons.site_icon_arrow,
              CSSClasses.pointerArrow
            ].join(" ")}
          /> */}
        </div>
      ) : null}

      <div
        className={[
          CSSClasses.pickerContainer,
          props.hasPrematchLegend ? CSSClasses.shrunkenPickerContainer : null
        ].join(" ")}
      >
        <SportPicker
          hasMagicWin={props.hasMagicWin}
          isPrematchPicker={props.isPrematchPicker}
          sportChanged={() => {
            sportChanged();
          }}
        />
      </div>

      {props.hasUserInfo ? (
        <div className={CSSClasses.userInfoContainer}>
          <UserInfo />
        </div>
      ) : null}

      {props.hasLiveSettings ? (
        <div className={CSSClasses.userInfoContainer}>
          {/* <LiveSettingsWidget /> */}

          <div
            className={CSSClasses.settingsButton}
            onClick={() => {
              if (this.beepHigh) {
                this.beepHigh.play();
              }

              props.changeSettingsPickerVisibility(
                !props.isShowingSettingsPicker
              );
              props.changeLanguagePickerVisibility(
                false //gasi sigurno
              );
            }}
          >
            <img src={iconSettings} alt="" className={CSSClasses.btnSettings} />

            {props.isShowingSettingsPicker ? (
              <img
                src={iconUp}
                alt=""
                className={CSSClasses.menuIndicatorSettings}
              />
            ) : (
              <img
                src={iconDown}
                alt=""
                className={CSSClasses.menuIndicatorSettings}
              />
            )}
          </div>

          <div
            className={CSSClasses.langButton}
            onClick={() => {
              if (this.beepHigh) {
                this.beepHigh.play();
              }

              props.changeLanguagePickerVisibility(
                !props.isShowingLanguagePicker
              );
              props.changeSettingsPickerVisibility(
                false //gasi sigurno
              );
            }}
          >
            <img
              src={require("../../assets/images/round_flags/" +
                props.currentLanguage +
                ".png")}
              alt=""
              className={CSSClasses.imgCountry}
            />

            <span className={CSSClasses.lblLanguageName}>
              {getIsoLangName(props.currentLanguage)}
            </span>

            {props.isShowingLanguagePicker ? (
              <img
                src={iconUp}
                alt=""
                className={CSSClasses.menuIndicatorLanguage}
              />
            ) : (
              <img
                src={iconDown}
                alt=""
                className={CSSClasses.menuIndicatorLanguage}
              />
            )}
          </div>

          {/* <Transition
            in={props.isShowingLanguagePicker}
            timeout={1000}
            mountOnEnter
            unmountOnExit
          >
            {state => (
              <div
                style={{
                  opacity: state === "exiting" ? 0 : 1,
                  transition: "opacity 500ms ease-out"
                }}
              >
                <LanguagePicker />
              </div>
            )}
          </Transition> */}

          {props.isShowingLanguagePicker ? <LanguagePicker /> : null}
          {props.isShowingSettingsPicker ? <SettingsLive /> : null}
        </div>
      ) : null}
    </div>
  );
};

const getLegendBackground = id => {
  switch (id) {
    case MostPlayedOptionIDs.FAVORIT_PLUS:
      return CSSClasses.bgdFavoritPlus;
    case MostPlayedOptionIDs.PREMATCH:
      return CSSClasses.bgdPrematch;
    case MostPlayedOptionIDs.SUPERTIP:
      return CSSClasses.bgdSupertip;
    case MostPlayedOptionIDs.TOP_LEAGUES:
      return CSSClasses.bgdTopLeagues;
    case MostPlayedOptionIDs.MOST_TIPPED:
      return CSSClasses.bgdMostTipped;
    default:
      return "";
  }
};

const getCurrentLegendIcon = id => {
  switch (id) {
    case MostPlayedOptionIDs.FAVORIT_PLUS:
      return SiteIcons.site_icon_plus;
    case MostPlayedOptionIDs.PREMATCH:
      return SiteIcons.site_icon_chalice;
    case MostPlayedOptionIDs.SUPERTIP:
      return SiteIcons.site_icon_crown;
    case MostPlayedOptionIDs.TOP_LEAGUES:
      return SiteIcons.site_icon_star;
    case MostPlayedOptionIDs.MOST_TIPPED:
      return SiteIcons.site_icon_fire;
    default:
      return "";
  }
};

const getCurrentTitle = id => {
  console.log("ID IS " + id);

  switch (id) {
    case MostPlayedOptionIDs.FAVORIT_PLUS:
      return "Favorit Plus";
    case MostPlayedOptionIDs.PREMATCH:
      return "Prematch";
    case MostPlayedOptionIDs.SUPERTIP:
      return "Supertip";
    case MostPlayedOptionIDs.TOP_LEAGUES:
      return "Top Lige";
    case MostPlayedOptionIDs.MOST_TIPPED:
      return "Najtipovaniji";
    default:
      return "??";
  }
};

const sportChanged = () => {
  //daj zvukic
  if (this.beepHigh) {
    //daj zvukic
    this.beepHigh.play();
  }
};

const getIsoLangName = wwinCode => {
  switch (wwinCode) {
    case "bs":
      return "ba";
    case "sr":
      return "rs";
    case "sl":
      return "si";
    default:
      return wwinCode;
  }
};

const mapStateToProps = state => {
  return {
    currentActiveLiveTheme: state.rrAppState.currentActiveLiveTheme,
    currentLanguage: state.rrAppState.currentLanguage,
    isShowingSettingsPicker: state.rrAppState.isShowingSettingsPicker,
    isShowingLanguagePicker: state.rrAppState.isShowingLanguagePicker,
    currentLiveSportID: state.rrNavigation.liveSportID,
    activeMostPlayedButtonID: state.rrNavigation.mostPlayedButtonID
  };
};

const mapDispatchToProps = dispatch => {
  return {
    changeSettingsPickerVisibility: isShown =>
      dispatch(StoreActions.SetSettingsPickerVisibility(isShown)),
    changeLanguagePickerVisibility: isShown =>
      dispatch(StoreActions.SetLanguagePickerVisibility(isShown))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Header);



// WEBPACK FOOTER //
// ./src/Containers/Header/Header.js